export const zhCN_menu = {
	'app.menu.parent': '顶级菜单',
	'app.menu.dashboard': '首页',
	'app.menu.dashboard.workbench': '工作台',
	'app.menu.dashboard.analysis': '分析页',

	'app.menu.form': '表单页',
	'app.menu.form.basic': '基础表单',
	'app.menu.form.advanced': '高级表单',
	'app.menu.form.editor': '富文本',

	'app.menu.list': '列表页',
	'app.menu.list.search': '搜索列表',

	'app.result': '结果页',
	'app.result.success': '成功页',
	'app.result.failed': '失败页',

	'app.abnormal': '异常页',
	'app.abnormal.403': '403',
	'app.abnormal.404': '404',
	'app.abnormal.500': '500',

	'app.org': '组织',
	'app.org.dept': '部门',
	'app.org.account': '账户',
	'app.org.role': '角色',
	'app.org.permission': '权限',

	'app.user': '个人',
	'app.user.center': '个人中心',
	'app.user.settings': '个人设置',

	'app.menu.login': '登录',
	'app.menu.config': '配置',
	'app.menu.config.search': '菜单管理',
	'app.menu.config.code.search': '字典管理',
	'app.menu.config.notice.search': '公告管理',
	'app.menu.config.schedule.search': '批处理管理',
	'app.menu.config.schedule.log': '批处理日志',
	'app.menu.config.theme': '主题设置',
	'app.menu.logs': '日志',
	'app.menu.logs.search': '日志管理',
	// 监控中心
	'app.menu.monitor': '监控中心',
	'app.menu.monitor.online': '在线用户',
	'app.menu.monitor.server': '服务监控',
	// 通知中心
	'app.menu.notice': '通知中心',
	'app.menu.notice.message': '站内信',
	// AI 能力
	'app.menu.ai': 'AI 能力',
	'app.menu.ai.mcp.servers': 'MCP 服务',
	'app.menu.ai.llm.providers': '模型供应商',
	'app.menu.ai.llm.prompts': '提示词',
	'app.menu.ai.training': '训练场',
	// 系统配置 —— 仅系统管理员可见(走 userStore.role 过滤),未来由后端 sys_menu 控制
	'app.menu.systemConfig': '系统配置',
	'app.menu.systemConfig.leadTemplate': '线索模板',
	// CRM 线索管理
	'app.menu.crm': 'CRM',
	'app.menu.crm.lead.template': '线索模板',
	'app.menu.crm.lead.fields': '线索模板', // 字段展示版(只读),与系统配置下的模板编辑版同名但不同
	'app.menu.crm.lead.source': '接入配置',
	'app.menu.crm.lead.mapping': '字段映射',
	'app.menu.crm.lead.rule': '分配规则',
	'app.menu.crm.lead.pool': '线索池',
	'app.menu.crm.lead.list': '线索清单',
	'app.menu.followPlan': '跟进计划',
	'app.menu.h5Preview': 'H5 预览',

	// 企微管理
	'app.menu.wecom': '企微管理',
	'app.menu.wecom.activeCode': '企微活码',
	'app.menu.wecom.colleague': '企微同事',
	'app.menu.wecom.group': '企微群聊',
	'app.menu.wecom.customer': '企微客户'
}
